








































import { Component, Vue, Prop } from 'vue-property-decorator';
import api from '@/api';
import constants from '@/utils/constants';

@Component
export default class PosOrderModal extends Vue {
  @Prop({ default: '' }) orderId?: string;
  @Prop({ default: '' }) defaultValue?: string;
  $swal: any;
  public showModal: boolean = true;
  public posOrderId: string = this.defaultValue || '';
  public submitting: boolean = false;

  submitOrderId() {
    this.$validator.validate().then(valid => {
      if (valid) {
        if (!this.posOrderId) {
          this.$swal(
            constants.SOMETHING_WROING,
            'Please input receipt number',
            constants.STATUS_ERROR
          );
          return;
        }
        if (this.orderId) {
          this.submitting = true;
          api
            .UpdatePosOrderInput({
              orderID: this.orderId,
              posOrderId: this.posOrderId
            }).then(res => {
            if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
              this.$swal(
                constants.SUCCESS_MESSAGE,
                'Order ID has been saved',
                constants.STATUS_SUCCESS
              );
              this.showModal = false;
              this.$emit('updateValue', this.posOrderId);
            } else {
              return this.$swal(
                constants.SOMETHING_WROING,
                res.data.invalidMessage,
                constants.STATUS_ERROR
              )
            }
          }).catch(err => {
            return this.$swal(
              constants.SOMETHING_WROING,
              err.message,
              constants.STATUS_ERROR
            )
          }).finally(() => {
            this.submitting = false;
          });
        } else {
          this.showModal = false;
          this.$emit('updateValue', this.posOrderId);
        }
      }
    });
  }
}
